import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined'
import { styled, Tooltip, IconButton } from '@mui/material'
import { drawerVar } from '../../../../../providers/apollo/cache'
import useSelectedMedia from '../../../hooks/useSelectedMedia'
import useBucket from '../../../hooks/useBucket'
import useBucketMigrationProgress from '../../../hooks/useBucketMigrationProgress'
import useBucketConvertProgress from '../../../hooks/useBucketConvertProgress'

const PillButton = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#fff',
  fontWeight: 500,
  fontSize: '0.875rem',
  cursor: 'pointer',
  gap: 8
})

export default function MediaOrganizePillButton() {
  const { selectedMedia } = useSelectedMedia()
  const { bucketUser, bucket } = useBucket()
  const bucketId = bucket?.id
  const mediaMovePermission = bucketUser?.permissions?.mediaUpdate
  const mediaIds: string[] = Array.from(selectedMedia.keys())
  const isMigrationInProgressForBucket = useBucketMigrationProgress()
  const isBucketConvertInProgressForBucket = useBucketConvertProgress()

  let title = 'Move Media'
  if (isMigrationInProgressForBucket || isBucketConvertInProgressForBucket) {
    title = 'Media move is disabled during the migration process'
  } else if (!mediaMovePermission) {
    title = 'Your role for this bucket does not allow you to move media.'
  } else if (!selectedMedia.size) {
    title = 'No Media Selected'
  }

  const disabled = !selectedMedia.size || !mediaMovePermission || isMigrationInProgressForBucket || isBucketConvertInProgressForBucket

  const handleClick = () => {
    if (!bucketId || !mediaIds.length) return
    drawerVar('bucketMediaMove')
  }

  if (disabled) {
    return null
  }

  return (
    <Tooltip title={title} arrow>
      <PillButton as="span">
        <IconButton
          color="inherit"
          aria-label="Move Media"
          disabled={disabled}
          onClick={handleClick}
          id="move-media-pill"
          data-test="move-media-pill"
          sx={{ color: '#fff' }}
        >
          <DriveFileMoveOutlinedIcon />
        </IconButton>
        <span style={{ color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#fff' }}>Organize</span>
      </PillButton>
    </Tooltip>
  )
}
